import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface SortableTableRowProps {
  'data-row-key': string;
  children: React.ReactNode;
  [key: string]: any;
}

const SortableTableRow: React.FC<SortableTableRowProps> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props['data-row-key'],
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    backgroundColor: isDragging ? 'var(--bg-hover)' : undefined,
  };

  // Clone children and inject drag listeners only to the first cell (drag handle)
  const children = React.Children.map(props.children, (child, index) => {
    if (index === 0 && React.isValidElement(child)) {
      // Add drag listeners to the first cell (drag handle column)
      const element = child as React.ReactElement<any>;
      return React.cloneElement(element, {
        ...listeners,
        style: { ...(element.props.style || {}), cursor: 'grab' }
      });
    }
    return child;
  });

  return (
    <tr
      {...props}
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      {children}
    </tr>
  );
};

export default SortableTableRow;